import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";

import { Box, Divider, Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../../components/style/modalStyle";

import FormInputField from "../../../components/common-components/FormInputField";
import { PhoneIcon } from "../../../assets/Icon/LlcForm";
import SelectInputField from "../../../components/common-components/SelectInputField";
import CustomButtonFormStep from "../../../components/common-components/CustomButtonStepperForm";
import CustomButton from "../../../components/common-components/CustomButton";
import { CrossIcon } from "../../../assets/Icon/ModalIcon";

interface AddressModalProps {
  open: boolean;
  handleClose: () => void;
  formik: any;
  closeModal?: () => void;
  stateList: any[];
  countryList: any[];
  loading?: boolean;
}

const AddressModal = ({
  open,
  handleClose,
  formik,
  closeModal,
  stateList,
  countryList,
  loading = false,
}: AddressModalProps) => {
  const previousCountry = useRef(formik.values.country);

  useEffect(() => {
    if (
      previousCountry.current &&
      previousCountry.current !== formik.values.country
    ) {
      formik.setFieldValue("state", "");
    }

    previousCountry.current = formik.values.country;
  }, [formik.values.country]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper
        sx={{
          width: {
            xs: "95%",
            sm: "850px",
          },
          maxHeight: "90vh",
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        {/* Header */}
        <Header>
          <Typography
            sx={{
              fontSize: "30px",
              fontWeight: 700,
            }}
          >
            Add Information
          </Typography>
        </Header>

        <Divider />

        {/* Content */}
        <Content
          sx={{
            overflowY: "auto",
            maxHeight: "65vh",
            padding: "20px",
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              {/* Phone */}
              <Grid item xs={12}>
                <FormInputField
                  placeholder="Enter phone number"
                  formik={formik}
                  name="phone_number"
                  icon={<PhoneIcon />}
                  isPhnNo={true}
                  showBorder={true}
                  label="Phone Number"
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12}>
                <FormInputField
                  placeholder="Enter address"
                  formik={formik}
                  name="member_address"
                  label="Address"
                  showBorder={true}
                />
              </Grid>

              {/* Country */}
              <Grid item xs={12} md={6}>
                <SelectInputField
                  formik={formik}
                  placeholder="Select country"
                  label="Country"
                  menuData={countryList}
                  name="country"
                  isCheckbox={true}
                  isState={true}
                  sendValue={true}
                  showBorder={true}
                />
              </Grid>

              {/* State */}
              <Grid item xs={12} md={6}>
                {formik.values.country === "United States" ? (
                  <SelectInputField
                    formik={formik}
                    placeholder="Select State"
                    label="State"
                    menuData={stateList}
                    name="state"
                    isCheckbox={true}
                    isState={true}
                    sendValue={true}
                    showBorder={true}
                  />
                ) : (
                  <FormInputField
                    placeholder="Enter state"
                    formik={formik}
                    name="state"
                    label="State"
                    showBorder={true}
                  />
                )}
              </Grid>

              {/* City */}
              <Grid item xs={12} md={6}>
                <FormInputField
                  placeholder="Enter city"
                  formik={formik}
                  name="member_city"
                  label="City"
                  showBorder={true}
                />
              </Grid>

              {/* Zip */}
              <Grid item xs={12} md={6}>
                <FormInputField
                  placeholder="Enter zip code"
                  formik={formik}
                  name="member_zip_code"
                  label="Zip Code"
                  showBorder={true}
                />
              </Grid>
            </Grid>

            {/* Footer Buttons */}
            <ButtonWrapper
              sx={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "12px",
                px: 0,
                py: 2,
              }}
            >
              <CustomButtonFormStep
                btnTitle="Back"
                handleClick={closeModal}
                bgColor="#EAF1FA"
                textColor="#2977CC"
              />

              <CustomButton
                btnTitle="Submit"
                minwidth="191px"
                type="submit"
                loading={loading}
              />
            </ButtonWrapper>
          </form>
        </Content>
      </ModalWrapper>
    </Modal>
  );
};

export default AddressModal;
